import { ReferenceDataDto } from '../../../../generated/auth/models/Sasfin/Dynamics/Api/Client/Models/DTO/reference-data-dto';

export interface IGenderState {
  list: ReferenceDataDto[];
  isLoading: boolean;
}

export const initialUIState = {
  // list: [],
  isLoading: false,
};
